import { PurchaseModel } from 'api-hooks/order/common';
import { NavigationRoutes } from 'common/constants';
import stylesColors from 'common/styles/styles.colors';
import Separator from 'components/common/separator';
import TableComponent, {
  IColumn,
} from 'components/elements/table-component/table-component';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

interface Props {
  data: PurchaseModel;
  navigation:
    | 'ActivityPurchasesView'
    | 'FlightPurchasesView'
    | 'HotelPurchasesView'
    | 'CruisePurchasesView'
    | 'DocumentPurchasesView'
    | 'ProductPurchasesView';
}

export default function ParentOrderRelatedTable(props: Props) {
  const { t } = useTranslation();
  const { data, navigation } = props;

  const _data = [data.parentPurchase, ...(data.childrenPurchases || [])].filter(
    (item) => !!item,
  );

  const columns = React.useMemo<IColumn<PurchaseModel>[]>(
    () => [
      {
        header: t('common:related_order'),
        accessorKey: 'number',
        minSize: 250,
        maxSize: 250,
      },
    ],
    [t],
  );

  return (
    <>
      <TableComponent
        columns={columns}
        data={_data || []}
        headerColor={stylesColors.bg1}
        rowLink={(row) => {
          return {
            pathname: NavigationRoutes[`${navigation}`],
            query: { id: row.original?.id },
          };
        }}
        showBorder
      />
      <Separator gap={16} />
    </>
  );
}
